import { Messages } from '../../../codegen/Localize';
import { Order } from '../../helpers/Order';
import { OrderKeys } from '../OrderKeys';
import { SortOptions } from './CommonSortOptions';
import { OptionsDictionary } from './SortOptionDefinitions';

export const metricsSortOptions: OptionsDictionary = {
  'name': SortOptions.name,
  /*
  'connectedViewName': {
    id: 'connectedViewName',
    getMenuItemDisplayValue: Messages.column_metrics_viewName,
    subSortOptions: {
      'asc': {
        id: 'connectedViewName.asc',
        field: OrderKeys.connectedViewName,
        getMenuItemDisplayValue: Messages.sortByAZ,
        getButtonDisplayValue: Messages.sortByConnectedViewAsc,
        ascending: true,
        toOrderClauseArray: () => [Order.asc(OrderKeys.connectedViewName)]
      },
      'desc': {
        id: 'connectedViewName.desc',
        field: OrderKeys.connectedViewName,
        getMenuItemDisplayValue: Messages.sortByZA,
        getButtonDisplayValue: Messages.sortByConnectedViewDesc,
        ascending: false,
        toOrderClauseArray: () => [Order.desc(OrderKeys.connectedViewName)]
      }
    }
  },
  */
  'project': SortOptions.projectName,
  'owner': {
    id: 'owner',
    getMenuItemDisplayValue: Messages.column_owner,
    subSortOptions: {
      'asc': {
        id: 'owner.asc',
        field: OrderKeys.ownerName,
        getMenuItemDisplayValue: Messages.sortByAZ,
        getButtonDisplayValue: Messages.sortByOwnerAsc,
        ascending: true,
        toOrderClauseArray: () => [Order.asc(OrderKeys.ownerName)]
      },
      'desc': {
        id: 'owner.desc',
        field: OrderKeys.ownerName,
        getMenuItemDisplayValue: Messages.sortByZA,
        getButtonDisplayValue: Messages.sortByOwnerDesc,
        ascending: false,
        toOrderClauseArray: () => [Order.desc(OrderKeys.ownerName)]
      }
    }
  },
  'modified': SortOptions.updated,
  'hits': SortOptions.hits,
};
